import React, {
  Fragment,
  useState,
  useEffect,
  useLayoutEffect,
  useContext,
} from "react";
import { MoreHorizontal } from "react-feather";
import Leftbar from "./LeftBar";
import Rightbar from "./RightBar";
import { Row } from "reactstrap";
import { useDispatch } from "react-redux";
import { toggleStyle } from "../../redux/toggleStyle";
import CustomizerContext from "../../helperContext/Customizer";

import Marquee from "react-fast-marquee";
import Welcome from "./Welcome";

const Header = () => {
  const dispatch = useDispatch();
  const [sidebartoogle, setSidebartoogle] = useState(true);
  const { toggleIcon, setToggleIcon } = useContext(CustomizerContext);

  function useWindowSize() {
    const [size, setSize] = useState([0, 0]);
    useLayoutEffect(() => {
      function updateSize() {
        setSize([window.innerWidth, window.innerHeight]);
        if (window.innerWidth <= 991) {
          setToggleIcon(true);
        } else {
          setToggleIcon(false);
        }
      }
      window.addEventListener("resize", updateSize);
      updateSize();
      return () => window.removeEventListener("resize", updateSize);
    }, []);
    return size;
  }
  // eslint-disable-next-line
  const [width] = useWindowSize();

  useEffect(() => {
    if (window.innerWidth <= 991) {
      setToggleIcon(true);
    } else {
      setToggleIcon(false);
    }
  }, []);

  const toggleResp = () => {
    dispatch(toggleStyle());
  };

  return (
    <Fragment>
      <div className={`page-main-header ${toggleIcon ? "close_icon" : ""}`}>
        <Row className="main-header-right m-0">
          <Leftbar
            sidebartoogle={sidebartoogle}
            setSidebartoogle={setSidebartoogle}
          />
          <Welcome />

          <Rightbar />
          <div
            className="d-lg-none mobile-toggle pull-right w-auto"
            onClick={() => toggleResp()}
          >
            <MoreHorizontal />
          </div>
        </Row>
      </div>
    </Fragment>
  );
};

export default Header;
